import React from 'react';

const CircularRating = ({ demand }) => {

  if (demand == null) {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-6 w-6"
        viewBox="0 0 20 20"
      >
        <circle cx="10" cy="10" r="8" fill="#cccccc" />
        <text
          x="50%"
          y="50%"
          textAnchor="middle"
          fill="#ffffff"
          fontSize="6"
          dy=".35em"
        >
          N/A
        </text>
      </svg>
    );
  }

  let arrowClasses = 'align-middle h-6 w-6 text-slate-200';
  if (demand === 1) {
    arrowClasses = 'align-middle h-6 w-6 text-emerald-500 rotate-0';
  } else if (demand === 3) {
    arrowClasses = 'align-middle h-6 w-6 text-slate-500 rotate-90';
  } else if (demand === 2) {
    arrowClasses = 'align-middle h-6 w-6 text-rose-500 rotate-180';
  }

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={arrowClasses}
      viewBox="0 0 20 20"
      fill="currentColor"
    >
      <path
        fillRule="evenodd"
        d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-8.707l-3-3a1 
        1 0 00-1.414 0l-3 3a1 1 0 001.414 1.414L9 9.414V13a1 
        1 0 102 0V9.414l1.293 1.293a1 1 0 001.414-1.414z"
        clipRule="evenodd"
      />
    </svg>
  );
};

export default CircularRating;